import { MARQUEE_TERMS, MARQUEE_TERMS_EN } from "@/lib/data";
import { useLanguage } from "@/context/LanguageContext";

export default function Marquee() {
  const { lang } = useLanguage();
  const terms = lang === "en" ? MARQUEE_TERMS_EN : MARQUEE_TERMS;
  const items = [...terms, ...terms];
  return (
    <div className="overflow-hidden border-y border-white/5 bg-[#070B14] py-5" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap" key={lang}>
        {items.map((term, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-slate-500">{term}</span>
            <span className="font-mono text-xs text-blue-500/60">{"//"}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
